// src/hooks/useCreationMode.js
import { useState, useCallback } from 'react';

/**
 * Hook for managing calendar event creation mode state
 * 
 * Creation mode is a special state where:
 * - Calendar clicks move preview event instead of opening panel
 * - Existing events become non-clickable  
 * - Preview event syncs with event creation panel
 * 
 * @returns {Object} Creation mode state and controls
 */
export const useCreationMode = () => {
  const [isInCreationMode, setIsInCreationMode] = useState(false);

  /**
   * Enter creation mode
   * Called when user clicks "Create Event" button
   */
  const enterCreationMode = useCallback(() => {
    console.log('🎨 Entering event creation mode');
    setIsInCreationMode(true);
  }, []);

  /**
   * Exit creation mode  
   * Called when event is created, cancelled, or other exit conditions
   */
  const exitCreationMode = useCallback(() => {
    console.log('🎨 Exiting event creation mode');
    setIsInCreationMode(false);
  }, []);

  /**
   * Toggle creation mode (for debugging/testing)
   */
  const toggleCreationMode = useCallback(() => {
    setIsInCreationMode(prev => {
      console.log('🎨 Toggling creation mode:', !prev);
      return !prev;
    });
  }, []);

  return {
    // State
    isInCreationMode,
    
    // Actions
    enterCreationMode,
    exitCreationMode,
    toggleCreationMode
  };
};

export default useCreationMode;